(() => {
  if (customElements.get('sticky-offer-bar')) return;

  const OFFSET_VAR = '--sticky-offerbar-offset';
  const OFFSET_CLASS = 'sticky-offer-bar-visible';

  const isPinned = (bar) =>
    (bar.classList.contains('is-sticky') || bar.classList.contains('is_sticky')) &&
    bar.getBoundingClientRect().height > 0;

  const updateOffset = () => {
    let offset = 0;
    document.querySelectorAll('sticky-offer-bar').forEach((bar) => {
      if (isPinned(bar)) offset = Math.max(offset, bar.getBoundingClientRect().height);
    });

    const root = document.documentElement;
    root.classList.toggle(OFFSET_CLASS, offset > 0);
    if (offset > 0) {
      root.style.setProperty(OFFSET_VAR, `${Math.round(offset)}px`);
    } else {
      root.style.removeProperty(OFFSET_VAR);
    }
  };

  class StickyOfferBar extends HTMLElement {
    constructor() {
      super();
      this.updateHeight = this.updateHeight.bind(this);
      this.classObserver = new MutationObserver(updateOffset);
    }

    connectedCallback() {
      this.updateHeight();
      window.addEventListener('resize', this.updateHeight);
      window.addEventListener('load', this.updateHeight);
      this.classObserver.observe(this, { attributes: true, attributeFilter: ['class'] });

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.updateHeight);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.updateHeight);
      window.removeEventListener('load', this.updateHeight);
      this.classObserver.disconnect();
      if (Shopify.designMode) {
        document.removeEventListener('shopify:section:load', this.updateHeight);
      }
      document.documentElement.style.removeProperty('--offerbar-height');
      document.documentElement.style.removeProperty('--offerbar-height-mobile');
      updateOffset();
    }

    updateHeight() {
      const height = this.offsetHeight;
      if (window.innerWidth > 767) {
        document.documentElement.style.setProperty('--offerbar-height', `${height}px`);
      } else {
        document.documentElement.style.setProperty('--offerbar-height-mobile', `${height}px`);
      }
      updateOffset();
    }
  }
  customElements.define('sticky-offer-bar', StickyOfferBar);
})();
